export enum FilterTypes {
  eligible = 'eligible',
  priceHigh = 'priceHigh',
  priceLow = 'priceLow',
  signRate = 'signRate',
  tags = 'tags',
  excludeTags = 'excludeTags',
  selectedCommissionModels = 'selectedCommissionModels',
}
